export const BANNER_CAMPAIGN_DEFAULT_LIMIT = 10;
export const BANNER_CAMPAIGN_MAX_LIMIT = 50;

export interface BannerCfgCampaignQuery {
  limit: number;
  offset: number;
  search?: string;
  channelId?: number;
  positionId?: number;
  useFlag?: "Y" | "N";
}

export interface BannerCfgCampaignPagination {
  limit: number;
  offset: number;
  totalItems: number;
}

export interface BannerCfgCampaignListResponse {
  code: string;
  desc: string;
  data: BannerCfgCampaign[] | null;
  pagination: BannerCfgCampaignPagination;
}

export interface BannerCfgCampaign {
  id: number;
  channelId: number;
  positionId: number;
  productOfferingId: string | null;
  nameTh: string;
  nameEn: string | null;
  descriptionTh: string | null;
  descriptionEn: string | null;
  useFlag: string;
  scheduleFlag: string;
  author: string;
  status: boolean;
  score: number;
  deleteDate: string | null;
  createdDate: string | null;
  createdBy: string;
  updatedDate: string | null;
  updatedBy: string;
  publicStatus: string | null;
  defaultFlag: string;
}

export type BannerCfgCampaignInput = Omit<
  BannerCfgCampaign,
  | "id"
  | "deleteDate"
  | "createdDate"
  | "createdBy"
  | "updatedDate"
  | "updatedBy"
>;

export interface BannerCfgCampaignDeleteResult {
  deleted: number;
  failed: { id: number; error: string }[];
}
